module.exports = __webpack_public_path__ + "static/img/banner-6-2.2346612.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/resources/banner-6-2.jpg
// module id = q2UK
// module chunks = 3 5